/**
 * @generated SignedSource<<9970244e07a0af4c17a3e41915cee373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardCard_getCountsQuery$variables = {};
export type DashboardCard_getCountsQuery$data = {
  readonly getCounts: {
    readonly totalCustomerCount: number;
    readonly totalLocationCount: number;
  };
};
export type DashboardCard_getCountsQuery = {
  response: DashboardCard_getCountsQuery$data;
  variables: DashboardCard_getCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DashboardObjectType",
    "kind": "LinkedField",
    "name": "getCounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCustomerCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalLocationCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardCard_getCountsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardCard_getCountsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0c618be6848c3fe1fa51d4c43ff938cc",
    "id": null,
    "metadata": {},
    "name": "DashboardCard_getCountsQuery",
    "operationKind": "query",
    "text": "query DashboardCard_getCountsQuery {\n  getCounts {\n    totalCustomerCount\n    totalLocationCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "394315365488b35a514a16c46ffd7236";

export default node;
